// 完成画面（2026-10-21 に app.js から分けた）
import { S } from './state.js';
import { NS, SIZE } from './config.js';
import { txt } from './text.js';
import { reduceMotion } from './store.js';
import { $ } from './util.js';
import { saveObject } from './core/savedata.js';
import { toast } from './history.js';
import { AUTO_KEY, SAVE_KEY, flushAutosave, writeStored } from './storage.js';
import { NAME_FONT, drawNameOnCanvas } from './name.js';
import { flash, photoIn } from './shutter.js';
import { downloadFinished } from './download.js';
import { openKiraseal } from './kira.js';
// 完成の画像（image）と、お披露目に送る名前なしの画像（ohirome。コピーライトは入る）を作る
// お披露目に名前を入れないのは 2026-10-22 から（ユーザー判断。名前の欄がお披露目でチャットのように使われ、悪口や人を探る書き込みが並んだため）
export function composeFinished() {
  const copy = S.stageSvg.cloneNode(true) as SVGSVGElement;
  const layer = copy.querySelector('#nameLayer');
  if (layer) layer.remove();
  let source = new XMLSerializer().serializeToString(copy);
  if (source.indexOf('xmlns=') < 0) source = source.replace('<svg', '<svg xmlns="' + NS + '"');
  return new Promise<{ image: string; ohirome: string }>((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = canvas.height = 1000;
      const ctx = canvas.getContext('2d')!;
      // 背景は透明のまま（本物の完成の画像と同じ。背景のパーツがあればそれが入る）
      ctx.drawImage(img, 0, 0, 1000, 1000);
      const fontReady = document.fonts && document.fonts.load ? document.fonts.load('47px ' + NAME_FONT) : Promise.resolve();
      fontReady.catch(() => {}).then(() => {
        const plain = ctx.getImageData(0, 0, 1000, 1000);
        drawNameOnCanvas(ctx, 1000, false);
        const ohirome = canvas.toDataURL('image/png');
        ctx.putImageData(plain, 0, 0);
        drawNameOnCanvas(ctx, 1000);
        resolve({ image: canvas.toDataURL('image/png'), ohirome });
      });
    };
    img.onerror = reject;
    img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(source);
  });
}
// 高画質DL（additional.js の largeImageDL）が 2000px で描く #chaSvgSave。名前は描かない（本物と同じ）。
// 本物は背景が別の svg（#chaSvgSaveBG）にあって入らず、説明（背景をオフにしたら透過）と合っていないので、モックは背景を入れる
export function setSaveSvg() {
  const holder = $('saveHolder');
  const copy = S.stageSvg.cloneNode(true) as SVGSVGElement;
  const layer = copy.querySelector('#nameLayer');
  if (layer) layer.remove();
  copy.id = 'chaSvgSave';
  copy.setAttribute('width', SIZE);
  copy.setAttribute('height', SIZE);
  copy.setAttribute('xmlns', NS);
  // 同じ id が2つにならないように（広場の avatar.js などは編集中のキャラの #chaSvgMake を見る）
  const make = copy.querySelector('#chaSvgMake');
  if (make) make.removeAttribute('id');
  holder.textContent = '';
  holder.appendChild(copy);
}
export function finish() {
  // 作りかけと「最後に完成したキャラ」を残す（本物の btnSaveChara と同じ）
  const now = saveObject();
  writeStored(AUTO_KEY, now);
  writeStored(SAVE_KEY, now);
  S.autosaveDirty = false;
  $<HTMLButtonElement>('btnFinish').disabled = true;
  // 完成したときの動き（シャッター）。光るのは画像を作っている間に見せる
  const motion = !reduceMotion.matches && !!Element.prototype.animate;
  Promise.all([composeFinished(), motion ? flash() : null]).then((r) => {
    const img = $<HTMLImageElement>('chaMakeResultImageView');
    img.charatOhirome = { src: r[0].image, image: r[0].ohirome }; // お披露目（additional.js）が送る名前なしの画像
    img.src = r[0].image; // 広場の avatar.js はこれが変わったときにキャラを用意する
    // 画像が描ける状態になってから出す（空の枠が一瞬見えないように）
    return (img.decode ? img.decode() : Promise.resolve()).catch(() => {}).then(() => {
      setSaveSvg();
      $('finishError').textContent = '';
      $('chaohirome').classList.remove('done');
      $('finish').hidden = false;
      $('finishBack').focus({ preventScroll: true });
      // 出し終わったら（シャッターの動きが終わってから）知らせる。完成画面のアニメ（ui/emote.js）はここで静止画と入れかわる
      (motion ? photoIn() : Promise.resolve()).then(() => {
        if (!$('finish').hidden) document.dispatchEvent(new CustomEvent('charatcreate:finishshown'));
      });
    });
  }, () => {
    toast(txt('finish_failed'));
  }).then(() => { $<HTMLButtonElement>('btnFinish').disabled = false; });
}
export function closeFinish() {
  if ($('finish').hidden) return;
  if (S.finishNeedsReload) { flushAutosave(true); location.reload(); return; }
  if (typeof window.hideModal === 'function') window.hideModal();
  $('sns-share-overlay').style.display = 'none';
  document.dispatchEvent(new CustomEvent('charatcreate:finishhidden'));
  $('finish').hidden = true;
  $('saveHolder').textContent = '';
  $('btnFinish').focus({ preventScroll: true });
}

export function bindFinish() {
  $('finishBack').addEventListener('click', closeFinish);
  $('finishDl').addEventListener('click', downloadFinished);
  $('finishKira').addEventListener('click', openKiraseal);
  if ($('chaplaza')) $('chaplaza').addEventListener('click', function () { // 広場のあるメーカーだけ（page.php の $ui['plaza']）
    if (typeof window.charatPlazaEnter === 'function') window.charatPlazaEnter(this.dataset.url);
  });
  // お披露目できたら（additional.js が #sns-share-overlay を出す）ボタンを「済み」に。購入できたら（決済の部品が入れかわる）印を付ける
  new MutationObserver(() => {
    if ($('sns-share-overlay').style.display !== 'none') { S.finishNeedsReload = true; $('chaohirome').classList.add('done'); }
  }).observe($('sns-share-overlay'), { attributes: true, attributeFilter: ['style'] });
  const content = document.querySelector('.paypal-modal .modal-content');
  if (content) new MutationObserver(() => {
    if (content.querySelector('#downloadButton, #orderPageLink')) S.finishNeedsReload = true;
  }).observe(content, { childList: true, subtree: true });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || $('finish').hidden) return;
    const pay = document.querySelector<HTMLElement>('.paypal-modal');
    if (pay && pay.style.display === 'block') { window.hideModal!(); return; }
    if ($('sns-share-overlay').style.display !== 'none') { $('sns-share-overlay').style.display = 'none'; return; }
    closeFinish();
  });
}
